export default __webpack_public_path__ + "static/media/DP2.13876173.svg";